module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/ko/1-55a85da1b406cd6d87c9cc3507ff1e93.jpg";